// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1SUXV","description":"PatientConsentPreview_description__2Z7pE"};